module.exports = __webpack_public_path__ + "static/img/ygfc4.696e4f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUs/ygfc4.png
// module id = n0kS
// module chunks = 2